// extracted by mini-css-extract-plugin
export default {"bottom-banner":"BottomBanner_bottom-banner__Mq8W9"};